// initial state
const state = () => ({
  showNotification:false,
  notificationMessage:"",
  notificationType:null
})

// getters
const getters = {
}

// actions
const actions = {
  displayNotification({ commit }, notification) {
    commit('saveNotificationMessage',notification.message);
    commit('saveNotificationType',notification.type);
    commit('saveShowNotification',notification.value);
    
  }
}

// mutations
const mutations = {
  saveShowNotification(state, value) {
    state.showNotification = value;
  },
  saveNotificationMessage(state, message) {
    state.notificationMessage = message;
  },
  saveNotificationType(state, type) {
    state.notificationType = type;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}